import { ChangeDetectorRef, Directive, effect, inject } from '@angular/core';
import { Textarea } from 'primeng/textarea';

@Directive({
  selector: '[appPrimengTextarea]',
  standalone: true,
})
export class PrimengTextareaDirective {
  private readonly textarea = inject(Textarea);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  private readonly initialClassList = this.getStyleClassList();

  public constructor() {
    effect(() => this.configureInputStyles());
  }

  private configureInputStyles(): void {
    const styles = [...this.initialClassList];
    const element = this.inputHtmlElement();

    element.className = '';
    element.classList.add(...styles);

    this.changeDetectorRef.detectChanges();
  }

  private getStyleClassList(): string[] {
    const { classList } = this.inputHtmlElement();

    return Array.from(classList);
  }

  private inputHtmlElement(): HTMLTextAreaElement {
    return this.textarea.el.nativeElement;
  }
}
